import React from "react";
import "./WhyMakeUsDifferent.css";
// import {
//   FaUserTie,
//   FaNetworkWired,
//   FaComments,
//   FaBolt,
//   FaBrain,
// } from "react-icons/fa";
import {
  FaUserTie,
  FaNetworkWired,
  FaComments,
  FaBolt,
  FaBrain,
} from "react-icons/fa";

const WhyMakeUsDifferent = () => {
  const features = [
    {
      icon: <FaUserTie />,
      title: "Real Industry Experience",
      desc: "Mentorship from professionals who’ve actually worked in tech, business, and consulting.",
    },
    {
      icon: <FaNetworkWired />,
      title: "Strong Corporate Network",
      desc: "Connected with 10,000+ HRs and 100+ companies across industries.",
    },
    {
      icon: <FaComments />,
      title: "Personalized Mentorship",
      desc: "One-on-one sessions focused on your exact skills and goals.",
    },
    {
      icon: <FaBolt />,
      title: "Career Without Compromise",
      desc: "We don’t rest until our students get placed — real results, not just promises.",
    },
    {
      icon: <FaBrain />,
      title: "Modern Learning Approach",
      desc: "Resume writing, LinkedIn optimization, interview training, and AI-powered job search skills.",
    },
  ];

  return (
    <section className="why-different">
      <div className="glow-bg"></div>
      <div className="why-different-container">
        <h2 className="why-heading">
          Why Students <span>Trust MBR Network’s</span>
        </h2>
        <div className="why-grid">
          {features.map((item, index) => (
            <div key={index} className="why-card">
              <div className="icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyMakeUsDifferent;
